import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

function buildPartyData (data) {
  return {
    birth_country_id: data.birth_country_id,
    deceased: data.deceased,
    dob: data.dob,
    first_name: data.first_name,
    gender_id: data.gender_id,
    last_name: data.last_name,
    middle_name: data.middle_name,
    nationality_ids: data.nationality_ids,
    city_of_birth: data.city_of_birth,
    state_of_birth: data.state_of_birth,
    uncertain_dob: data.uncertain_dob,
  }
}

export const PEPersonalDetailsCardActions = {
  initPePersonalDetailsCard: ({ commit }) => {
    commit('setPePersonalDetailsCardLock', true)
  },
  peCreateParty: async ({ commit }, { party, recordId = null, legalCaseId = null }) => {
    return axiosRequest.
      post('/parties', { party, record_id: recordId, legal_case_id: legalCaseId }).
      then(({ data }) => {
        commit('peSetParty', data?.party)
        commit('setPePersonalDetailsCardLock', true)
      }).
      catch(handleError)
  },
  pePersonalDetailsCardRefresh: async ({ commit, getters }) => {
    const party = getters.peParty

    return axiosRequest.
      get(`/parties/${party.id}`).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPePersonalDetailsCardLock', true)
        commit('pePatchParty', buildPartyData(updatedParty))
      }).
      catch(handleError)
  },
  pePersonalDetailsCardUpdate: async ({ commit }, { id, section }) => {
    return axiosRequest.
      patch(`/parties/${id}`, {
        ...buildPartyData(section),
        id: section.id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPePersonalDetailsCardLock', true)
        commit('pePatchParty', buildPartyData(updatedParty))
      }).
      catch(handleError)
  },
}

export const PEPersonalDetailsCardMutations = {
  setPePersonalDetailsCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'personalDetailsCard', lock)
  },
}

export const PEPersonalDetailsCardGetters = {
  pePersonalDetailsCardLock: state => state.partyEdit.partySections.personalDetailsCard,
}
